import React from 'react';
import RoleSuccessPage from '../RoleManagement/RoleSuccessPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './AgentSuccessPage.module.css';
import qrCode from '../../assets/images/qr-admin.png';

const AgentSuccessPage: React.FC = () => (
  <RoleSuccessPage config={ROLE_CONFIGS.agent} styles={styles} staticQrImage={qrCode} />
);

export default AgentSuccessPage;
